import styled from 'styled-components';
import ConferenceRoomIconSvg from '../../assets/hotels/amenities/conference-room.svg';

const ConferenceRoomIcon = styled(
  ConferenceRoomIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ConferenceRoomIcon;
